import { render, staticRenderFns } from "./ClaimView.vue?vue&type=template&id=32162e4c&scoped=true"
import script from "./ClaimView.vue?vue&type=script&lang=js"
export * from "./ClaimView.vue?vue&type=script&lang=js"
import style0 from "./ClaimView.vue?vue&type=style&index=0&id=32162e4c&prod&lang=css"
import style1 from "./ClaimView.vue?vue&type=style&index=1&id=32162e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32162e4c",
  null
  
)

export default component.exports